function removeHTMLTags(html) {
  // Remove HTML tags and attributes using a regular expression
  const plainText = html.replace(/<[^>]*>/g, '');

  return plainText;
}

export default removeHTMLTags;
